const Ajv = require('ajv');
const RegexDefaultNameFormat = /^[a-zA-Z0-9.!#$%&'*+\-/=?^_`{|}~][a-zA-Z0-9 .!#$%&'*+\-/=?^_`{|}~]*$/;

module.exports.create = function (schemas) {
  const ajv = new Ajv(schemas);
  ajv.addKeyword('defaultNameFormat', {
    compile: (schema, parentSchema) => {
      const { minLength } = parentSchema;
      function validationFunction(data, dataPath, parentData, parentDataProperty) {
        const validFormat = RegexDefaultNameFormat.test(data);
        if (!validFormat) {
          validationFunction.errors = [
            {
              keyword: 'pattern',
              message: `should match pattern "${RegexDefaultNameFormat.source}"`,
              params: {
                pattern: RegexDefaultNameFormat.source,
              },
            },
          ];
          return false;
        }
        const trimmedString = data.trim();
        if (trimmedString.length < minLength) {
          validationFunction.errors = [getMinLengthError(minLength)];
          return false;
        }
        parentData[parentDataProperty] = trimmedString;
        return true;
      }
      return validationFunction;
    },
    modifying: true,
  });
  ajv.addKeyword('noEmptySpaces', {
    type: 'string',
    compile: (schema, parentSchema) => {
      return function validationFunction(data, dataPath, parentData, parentDataProperty) {
        const { minLength } = parentSchema;
        const trimmedString = data.trim();
        parentData[parentDataProperty] = trimmedString;
        if (trimmedString.length < minLength) {
          validationFunction.errors = [getMinLengthError(minLength)];
          return false;
        }
        return true;
      };
    },
  });
  return ajv;
};

function getMinLengthError(minLength) {
  return {
    keyword: 'minLength',
    message: `should NOT be shorter than ${minLength} characters`,
    params: {
      limit: minLength,
    },
  };
}
